(() => {
  angular.module('app').component('commonClaimsProcessClaimDetailSpecialistTicketItemsComponent', {
    templateUrl: require('./specialistTicketItems.component.html'),
    controller: SpecialistTicketItemsController,
    controllerAs: 'vm',
    bindings: {
      disciplines: '<',
      currencyCode: '<',
      treatmentCategories: '<',
      sections: '=',
      isTotalBillAmountValid: '<',
      treatmentHasValue: '<',
      treatmentMissed: '<',
      showDiscipline: '<',
      isDisciplineRequired: '<',
      hasSelfManageNpr: '<',
    },
  });

  SpecialistTicketItemsController.$inject = ['$uibModal', 'Hms.PatientTickets.PatientTicketItem'];

  function SpecialistTicketItemsController($uibModal, constsPatientTicketItem) {
    const vm = this;

    vm.constsPatientTicketItem = constsPatientTicketItem;

    vm.addSection = addSection;
    vm.removeSection = removeSection;
    vm.addTreatment = addTreatment;
    vm.removeTreatment = removeTreatment;
    vm.clearTreatment = clearTreatment;
    vm.editTreatment = editTreatment;

    init();

    function init() {}

    function addSection() {
      vm.sections.push({
        treatments: [{}],
      });
    }

    function removeSection(sectionId) {
      vm.sections.splice(sectionId, 1);
    }

    function addTreatment(sectionId) {
      vm.sections[sectionId].treatments.push({});
    }

    function removeTreatment(sectionId, treatmentId) {
      vm.sections[sectionId].treatments.splice(treatmentId, 1);
    }

    function clearTreatment(sectionId) {
      vm.sections[sectionId].treatments = [{}];
    }

    function editTreatment(sectionId, treatmentId) {
      const treatmentItem = vm.sections[sectionId].treatments[treatmentId];

      $uibModal
        .open({
          templateUrl: require('./editTicketItemModal/editTicketItemModal.modal.html'),
          controller: 'common.views.claim.process.editTicketItemModal as vm',
          backdrop: 'static',
          resolve: {
            treatmentItem,
            currencyCode: () => vm.currencyCode,
            treatmentCategories: () => vm.treatmentCategories,
            treatmentMissed: () => vm.treatmentMissed,
            isTotalBillAmountValid: () => vm.isTotalBillAmountValid,
            treatmentHasValue: () => vm.treatmentHasValue,
          },
        })
        .result.then((updatedTicketItem) => {
          vm.sections[sectionId].treatments[treatmentId] = {...updatedTicketItem};
        });
    }
  }
})();
